import { render, staticRenderFns } from "./WSeminarList.vue?vue&type=template&id=29719462&"
import script from "./WSeminarList.vue?vue&type=script&lang=js&"
export * from "./WSeminarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports